export const NPAPOPUP="NPAPOPUP"
export const NPAPOPUP_SUCCESS="NPAPOPUP_SUCCESS"
export const NPAPOPUP_FAIL="NPAPOPUP_FAIL"